import { render } from "./FooterCopyright.vue?vue&type=template&id=3f6e8b92"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import exportComponent from "C:\\DEV\\Projects\\2025_ostrowskiortopeda_pl\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__